import { LANGUAGES } from '@/constants/languages'
import { IShotlist } from '@/types/shotlist.interface'
import { ILanguage } from '@/types/task.interface'

interface IGetFileDerivedDataParams {
	shotlist?: IShotlist
	languages?: ILanguage[]
	leftTab: 'original' | 'en' | 'ru' | 'ar' | 'es'
	rightTab: string | null
	isInt?: string
}

export const getFileDerivedData = ({
	shotlist,
	languages,
	leftTab,
	rightTab,
	isInt
}: IGetFileDerivedDataParams) => {
	const isTranslation = shotlist?.translations.length > 0

	const translations = shotlist?.translations || []

	const availableShotlistLanguages = [
		shotlist?.original,
		...translations
	].filter(Boolean)

	const excluded = [
		'original',
		...(shotlist?.original?.language ? [shotlist.original.language] : []),
		...(isInt ? ['ru'] : [])
	]

	const allPlatformsLanguages = Object.keys(LANGUAGES).filter(
		lang => !excluded.includes(lang)
	)

	const leftTranslationLanguage = shotlist?.translations.find(translation => {
		return translation.language === leftTab
	})

	const rightTranslationLanguage = shotlist?.translations.find(translation => {
		return translation.language === rightTab
	})

	const leftRenderLanguage =
		leftTab === 'original'
			? shotlist?.original
			: leftTranslationLanguage || shotlist?.original

	const rightRenderLanguage = rightTranslationLanguage || translations[0]

	const translationLanguages = shotlist && [
		...shotlist.translations.map(item => item.language),
		'original'
	]

	const noTexts =
		!shotlist?.original?.content && shotlist?.translations?.length === 0

	const onlyOriginal =
		shotlist?.original?.content && shotlist?.translations?.length === 0

	const originalLang = languages?.find(
		lang => lang.code === shotlist?.original?.language
	)?.language

	const originalSourceName = shotlist?.original?.filename
		? `Uploaded from ${shotlist?.original?.filename}`
		: `Transcribed by Stenogram from ${originalLang}`

	return {
		isTranslation,
		translations,
		availableShotlistLanguages,
		excluded,
		allPlatformsLanguages,
		leftTranslationLanguage,
		rightTranslationLanguage,
		leftRenderLanguage,
		rightRenderLanguage,
		translationLanguages,
		noTexts,
		onlyOriginal,
		originalLang,
		originalSourceName
	}
}
